import { ComponentManager, ControlViewModel } from "radpresentation.htmlclient.defaultviewextensions";

export default class TaskDescriptionViewModel extends ControlViewModel {
    /**
     * Der Kontext des ViewModels
     */
    public context: any;

    /**
     * Ein DTO-Objekt mit Informationen über die Aufgabe
     * @type {WFEUserTaskCompleteInformationDTO}
     */
    public WFEUserTaskCompleteInformationDTO: any;

    constructor(params: any) {
        super(params);
        this.context = this.paramOrDefault(params.context, null);
        this.WFEUserTaskCompleteInformationDTO = this.observableOrDefault(params.WFEUserTaskCompleteInformationDTO, null);
        ControlViewModel.checkProperties(this, params);
    }
}

ComponentManager.setViewModel('TaskDescriptionViewModel', TaskDescriptionViewModel, 'WorkflowEngineHTMLViewExtension');